import React from "react";

const SettingsCard = ({item, onClick, height = null}) => {
  return (
    <div
      className={`card-glass ${height ? "" : "h-full"}`}
      style={height ? {height} : {}}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center mb-4">
          <div>
            <h3 className="text-xl font-semibold text-gray-100 flex-grow">
              {item.name}
            </h3>
            🔑 <span className="text-gray-200 font-mono text-lg">{item.key}</span>
          </div>
        </div>
        <div className="flex items-center mb-4">
        </div>
        <div className="relative group flex-grow">
          <p className="text-gray-300 mb-4 line-clamp-3 text-sm overflow-hidden">
            {item.description}
          </p>
          <div className="hint-glass">{item.description}</div>
        </div>
        <div className="relative group flex-grow">
          <h4 className="text-gray-100">Content:</h4>
          <div className="text-white mb-4 line-clamp-3 bg-gray-900 font-mono text-sm rounded-md m-2">
            {item.content}
          </div>
        </div>
        <div className="flex">
          <span
            className={`ml-2 py-1 px-3 rounded-sm text-xs font-medium ${
              item.format === "markdown"
                ? "bg-green-600 text-white"
                : item.format === "json"
                  ? "bg-blue-600 text-white"
                  : item.format === "yaml"
                    ? "bg-purple-600 text-white"
                    : item.format === "dropdown"
                      ? "bg-teal-600 text-white"
                      : "bg-gray-600 text-white"
            }`}
          >
            {item.format.toUpperCase()}
          </span>
          <div className="flex-1 text-right">
            <div className="text-sm text-gray-400">
              {/* {item.updated_by.replaceAll("@lumeris.com", "")} at */}
              {new Date(item.updated_at).toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsCard;
